/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:51:24
 * @LastEditTime: 2023-10-30 18:42:37
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-statistic-analy\modules\businessFlowDimensionRouter.js
 * 商务流向维度
 */
const businessFlowDimensionRouter = [
  // 商业销售统计
  {
    path: '/flowSystem/business-sales-statistics',
    name: 'flowSystemStatisticsBusinessSales',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatisticsBusiness" */
      //   '../views/flowSystem/statistics/BusinessSales.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatisticsBusiness" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/commercial-sales-statis/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '商业销售统计'
    }
  },
  // 商业进销存统计
  {
    path: '/flowSystem/business-sales-inventory-statistics',
    name: 'flowSystemStatisticsBusinessSalesInventory',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics1" */
      //   '../views/flowSystem/statistics/BusinessSalesInventory.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/purchase-sales-statis/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '商业进销存统计'
    }
  },
  // 进销存统计-按商业
  {
    path: '/flowSystem/business-purchase-sales',
    name: 'flowSystemBusinessPurchaseSales',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/business-purchase-sales/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '进销存统计-按商业'
    }
  },
  // 库存设置 进销存统计按商业
  {
    path: '/flowSystem/inventory-settings-business',
    name: 'flowSystemStatisticsInventorySettingsBusiness',
    component: () =>
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/business-purchase-sales/InventorySet.vue'
      ),
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '库存设置',
      breadcrumb: [
        {
          title: '进销存统计-按商业',
          name: 'flowSystemBusinessPurchaseSales'
        }
      ]
    }
  },
  // 进销存统计-按批次
  {
    path: '/flowSystem/batch-purchase-sales',
    name: 'flowSystemBatchPurchaseSales',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/batch-purchase-sales/Page.vue'
      ), //
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '进销存统计-按批次'
    }
  },
  // 库存设置
  {
    path: '/flowSystem/inventory-settings',
    name: 'flowSystemStatisticsInventorySettings',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem5" */
      //   '../views/flowSystem/statistics/InventorySettings.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystem5" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/purchase-sales-statis/InventorySetting.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '库存设置',
      breadcrumb: [
        {
          title: '商业进销存统计',
          name: 'flowSystemStatisticsBusinessSalesInventory'
        }
      ]
    }
  },
  // 商业库存分析
  {
    path: '/flowSystem/inventory-analysis-statistics',
    name: 'flowSystemStatisticsInventoryAnalysis',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics2" */
      //   '../views/flowSystem/statistics/InventoryAnalysis.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics2" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/inventory-analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '商业库存分析'
    }
  },
  // 商业-终端销售查询
  {
    path: '/flowSystem/business-client',
    name: 'masterDataSystemBusinessClient',
    component: () =>
      // import(
      //   /*webpackChunkName:"masterDataSystemSubsidiary" */
      //   '../views/flowSystem/statistics/BusinessClient'
      // ),
      import(
        /*webpackChunkName:"masterDataSystemSubsidiary" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/sales-query/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '商业-终端销售查询'
    }
  },
  // 窜货分析
  {
    path: '/flowSystem/fleeing-goods-statistics',
    name: 'flowSystemStatisticsFleeingGoods',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/FleeingGoods.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/fleegood-analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '窜货分析'
    }
  },
  // 窜货详细数据
  {
    path: '/flowSystem/fleeing-goods-detail',
    name: 'flowSystemStatisticsFleeingGoodsDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '../views/flowSystem/statistics/FleeingGoodsDetail.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/fleegood-analy/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '窜货详细数据',
      breadcrumb: [
        {
          title: '窜货分析',
          name: 'flowSystemStatisticsFleeingGoods'
        }
      ]
    }
  },
  // 疑似窜货流向
  {
    path: '/flowSystem/is-fleeing-goods',
    name: 'flowSystemStatisticsIsFleeingGoods',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics4" */
      //   '@/views/flowSystem/statistics/IsFleeingGoods.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics4" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/fleegood-analy/seemingly.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '疑似窜货流向',
      breadcrumb: [
        {
          title: '窜货分析',
          name: 'flowSystemStatisticsFleeingGoods'
        }
      ]
    }
  },
  // 渠道汇总分析
  {
    path: '/flowSystem/channel-summary-statistics',
    name: 'flowSystemStatisticsChannelSummary',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/ChannelSummary.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/channel-summary-analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '渠道汇总分析'
    }
  },
  // 流向覆盖统计
  {
    path: '/flowSystem/Flow-direction-coverage-statistics',
    name: 'flowSystemStatisticsFlowDirectionCoverageStatistics',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics3" */
      //   '../views/flowSystem/statistics/FlowDirectionCoverageStatistics.vue'
      // ),
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/business-coverage-statis/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '商业覆盖统计'
    }
  },
  // 商业滞销分析
  {
    path: '/flowSystem/commercial-unsales-analysis',
    name: 'flowSystemCommercialUnsalesAnalysis',
    component: () =>
      import(
        /*webpackChunkName:"flowSystemStatistics3" */
        '@/views/butterfly-flow-system/flow-direction-statistic-analy/business-flow-dimension/commercial-unsales-analysis/Page.vue'
      ),
    meta: {
      SecondaryMenu: '商业流向维度', //二级菜单
      title: '商业滞销分析'
    }
  }
]
export default businessFlowDimensionRouter
